import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {formatCurrency, handleDefaultValues} from "../../common/Utils";
import {useForm} from 'react-hook-form';
import {
  getMyInventoryGiftCards
} from "../../common/api/PortalCustomerApi";
import {Card, CardContent, Chip, Divider, Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import ViewInventoryModal from "../modal/ViewInventoryModal";
import {CartContext} from "../../../lib/CartProvider";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import GiftCardQrCode from "../modal/GiftCardQrCode";
import QrCodeIcon from "@mui/icons-material/QrCode";
import MDButton from "../../../components/MDButton";
import CustomerRedeemGiftCard from "../CustomerRedeemGiftCard";

export default function CustomerGiftCardsMiniPane(props) {
  const [context, setContext] = useContext(AppContext);
  const [cartContext, setCartContext] = useState(CartContext);

  const [eventReady, setEventReady] = useState(false);
  const [event, setEvent] = useState();
  const [giftCards, setGiftCards] = useState([]);

  useEffect(() => {
    getInventoryFn()
  }, []);

  const [inventory, setInventory] = useState();
  const [showMembershipModal, setShowMembershipModal] = useState(false);
  const [savingMembership, setSavingMembership] = useState(false);
  const [inventoryType, setInventoryType] = useState();
  const [formInvalid, setFormInvalid] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryType)
  });

  const handleClose = () => {
    setShowMembershipModal(false);
  };

  const handleSave = (data) => {
    props.handleSave(data);
  };

  const getInventoryFn = async () => {
    let result = await getMyInventoryGiftCards();
    setGiftCards(result);
  }

  const viewInventory = (e) => {
    setInventory(e);
    setShowMembershipModal(true);
  };

  const loadCartFn = () => {

    setCartContext({...cartContext, reloadCart: true, caller: 'inventory mini pane'})

    let _context = {...context};
    _context.toast = {
      message: 'Added to cart!',
      type: 'success'
    }
    setContext({..._context});
  };

  const [showRedeemCard, setshowRedeemCard] = useState(false);
  const [showGiftCardQR, setShowGiftCardQR] = useState(false);
  const [giftCardQrCode, setGiftCardQrCode] = useState(null);

  const printQrGiftCard = (card) => {
    setShowGiftCardQR(true);
    setGiftCardQrCode(card);
  }

  const [renderNum, setRenderNum] = useState(1);

  return (
    <>
      <Card>
        <CardContent>

          <h5>Gift Cards
            <MDButton size={'small'} color={'secondary'} className={'pull-right'}
                      onClick={(e) => {
                        setshowRedeemCard(true);
                      }}>Redeem Gift Card</MDButton>
          </h5>
          <Divider/>
          {giftCards?.length > 0 && <>
            <MDBox>
              <Grid container cols={2} spacing={2} direction="row">
                <Grid item sm={12}>
                  <Grid container spacing={2}>

                    {giftCards?.sort((a, b) => new Date(a.createDate).getTime() - new Date(b.createDate).getTime())
                      .filter(inventory => inventory?.currentBalance > 0) //
                      .map((card, index) => {
                        return (
                          <Grid item xs={12} key={index}
                                className={'d-inline-grid'}>
                            <div className={'psb-bordered'}>
                              <div>
                                <Grid container spacing={2}>
                                  <Grid item xs={6} sm={2}>
                                    {card?.imageUrl ? <img
                                      style={{
                                        maxWidth: '90%',
                                        height: 'auto'
                                      }}
                                      alt={card.name}
                                      src={card?.imageUrl}
                                    /> : <span style={{fontSize: '32px'}}><CardGiftcardIcon/></span>
                                    }
                                  </Grid>
                                  <Grid item xs={6} sm={10}>
                                    <h3>
                                      {card.name}&nbsp;
                                    </h3>
                                    <h6>
                                      {formatCurrency(card?.currentBalance)}&nbsp;
                                    </h6>

                                    {card?.transferCode &&
                                      <p style={{
                                        fontSize: '24px',
                                        textAlign: 'right',
                                        margin: '0'
                                      }}>
                                        <a href={"#"}
                                           alt={'Transfer Gift Card'}
                                           title={'Transfer Gift Card'}
                                           onClick={(e) => {
                                             e.preventDefault();
                                             printQrGiftCard(card)
                                           }}><QrCodeIcon/></a>
                                      </p>
                                    }

                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        )
                      })
                    }

                  </Grid>
                </Grid>
              </Grid>
            </MDBox>
          </>}
        </CardContent>
      </Card>

      {showRedeemCard && <CustomerRedeemGiftCard
        show={showRedeemCard} handleClose={() => {
        setshowRedeemCard(false)
      }} handleSave={()=>{
        setshowRedeemCard(false);
        getInventoryFn();
      }}/>}

      {
        inventory && <ViewInventoryModal
          key={inventory?.guid}
          handleClose={handleClose}
          handleSave={handleSave}
          membershipType={false}
          show={showMembershipModal}
          inventory={inventory}
        />
      }

      {renderNum && showGiftCardQR && <GiftCardQrCode show={showGiftCardQR}
                                                      giftCard={giftCardQrCode}
                                                      handleClose={() => {
                                                        setGiftCardQrCode(null);
                                                        setShowGiftCardQR(false);
                                                      }}
      />}


    </>
  )
}